import { useCurrentProjectId } from './path-params-extraction.hooks';

export enum PanelType {
  Organization = 'organization',
  Project = 'project'
}

export const usePanelType = (): PanelType => {
  const projectId = useCurrentProjectId();
  return projectId ? PanelType.Project : PanelType.Organization;
};
